import React , {useRef, useState} from 'react'
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClipLoader from "react-spinners/ClipLoader"; 
import { Link } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha';

const ProductForm = ({ prm }) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY;
  const [enquiry, setEnquiry] = useState(prm);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");  
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(true);
  const [disableButton, setDisableButton] = useState(false);
  const [spinnerClass, setSpinnerClass] = useState('invisible');
  const [isVisible, setIsVisible] = useState('visible');
  const [showMessage, setShowMessage] = useState('invisible');  
  const [msg, setMsg] = useState("");

  const recaptchaRef = useRef(null);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);  
  const [isValidCaptcha, setIsValidCaptcha] = useState("");

  const handleCaptchaChange = (token) => {
    setIsCaptchaVerified(!!token);
  };

  const resetCaptcha = () => {
    recaptchaRef.current?.reset();
    setIsCaptchaVerified(false);
    setIsValidCaptcha("Valid");
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors({});
      return;
    }     
  };

  const toggleDisableButton = () => {
    setDisableButton(!disableButton);
    setIsChecked(!isChecked);
  };
  const changeClass = () => {
    setSpinnerClass('visible');
    setIsVisible('invisible');
  };

// Validation function for email and password
const validateForm = () => {
    const errors = {};
    if (!firstName) {
        errors.firstName = "First name is required";
    }
    if (!lastName) {
        errors.lastName = "Last name is required";
    }
    if (!phone) {
        errors.phone = "Contact number is required";
    }    
    if (!email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Please enter a valid email address";
    }
    if (isCaptchaVerified === false) {
      errors.isValidCaptcha = "Please verify the CAPTCHA before submitting";
    }
    return errors;
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    if (!isCaptchaVerified) {
      return;
    }    
    changeClass();
    const frmtype  = 2;
    const apiUrl = apiBaseUrl + `sendmail?form_type=2&enquiry_type=${enquiry}&first_name=${firstName}&last_name=${lastName}&contact_number=${phone}&email=${email}&location=&message=${message}`;
    await axios.get(apiUrl).then((res)=>{
        setSpinnerClass('invisible');
        setIsVisible('visible');
        setMsg(res.data.msg);
        //console.log('Send Data:', res);
        if (res.data.success === true) {
            toast("Mail sent successfully");
            setFirstName("");
            setLastName("");
            setPhone("");
            setEmail("");
            setMessage("");
            setEnquiry(prm);
            setShowMessage('visible');
        } else {
            toast(res.data.error || "Mail not sent");
        }        
      }).catch((err)=>{
        //console.log('Invalid Email :', err);
        setSpinnerClass('invisible');
        setIsVisible('visible');
        setShowMessage('visible');
        toast("Something went wrong. Please try again later.");
    })
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional, for smooth scrolling
    });
  }; 

    return (
    <>
        <ToastContainer/>
        <form className="appoinment-form row" onSubmit={handleSubmit}> 
            <div className="form-group col-md-6">
                <label>First name <span className="text-danger"><strong>*</strong></span></label>
                <input 
                    className="form-control" 
                    placeholder="First name" 
                    type="text" 
                    name="first_name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    autoComplete="false"                 
                    required/>
                    {errors.firstName && <span className="error-message">{errors.firstName}</span>}
            </div>
            <div className="form-group col-md-6">
                <label>Last name <span className="text-danger"><strong>*</strong></span></label>
                <input 
                    className="form-control" 
                    placeholder="Last name" 
                    type="text" 
                    name="last_name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    autoComplete="false"                  
                    required/>
                    {errors.lastName && <span className="error-message">{errors.lastName}</span>}
            </div>                                
            <div className="form-group col-md-12">
                <label>Contact number <span className="text-danger"><strong>*</strong></span></label>
                <input
                    className="form-control" 
                    placeholder="Contact number" 
                    type="text" 
                    name="contact_number"
                    maxLength={10}
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    autoComplete="false"                
                    required/>
                    {errors.phone && <span className="error-message">{errors.phone}</span>}
            </div>
            <div className="form-group col-md-12">
                <label>Email <span className="text-danger"><strong>*</strong></span></label>
                <input 
                    className="form-control" 
                    placeholder="Email" 
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="false"
                    required/>
                    {errors.email && <span className="error-message">{errors.email}</span>}
            </div>
            <div className="form-group col-md-12 col-sm-12 col-xs-12">
                <label>Message</label>
                <textarea 
                    className="form-control" 
                    rows="4" 
                    name="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    autoComplete="false"                  
                    placeholder="Leave us your message..."></textarea>
            
            </div>
            <div className="form-group col-md-10 col-sm-10 col-lg-10 col-xs-9">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={recaptchaKey}
                className="input-control google-recaptch-wrapper"
                onChange={handleCaptchaChange}
              />  
            </div>
            <div className="col-md-2 col-sm-2 col-lg-2 col-xs-3 text-center">
              <span 
                className="form-control refresh-btn-wrapper" 
                onClick={resetCaptcha}><i className="fa fa-refresh"></i></span>
            </div>
            {errors.isValidCaptcha && 
            <>
            <div className="form-group col-md-12">
              <span className="error-message">{errors.isValidCaptcha}</span>
            </div>
            </>
            }                
            <div className="form-group col-md-12 col-sm-12 col-xs-12">
                <p><input 
                    type="checkbox" 
                    name="chkPolicy"
                    onChange={toggleDisableButton}
                    checked = { isChecked } 
                    required /> You agree to our <Link to="/privacy-policy" onClick={scrollToTop}>privacy policy</Link>.</p>
            </div>            
            <div className="form-group col-md-12 col-sm-12 col-xs-12 text-center">
                <button 
                    className={`${isVisible} btn btn-lg btn-appointment-submit`}
                    type="submit" 
                    disabled={disableButton}>
                        Request Call Back
                </button>                                    
                <span className={`${spinnerClass} btn btn-lg btn-appointment-submit`}>
                    <ClipLoader
                        loading={true}
                        size={30}
                        color={"#ffffff"}/>                            
                </span>                                    
            </div>
            {!!(msg) && (
              <div className="form-group col-md-12 col-sm-12 col-xs-12 custom-message text-center">
                <span className={`${showMessage} text-center text-success`}>{msg}</span>  
              </div>
            )}             
        </form>
    </>
    )
}

export default ProductForm